/** Only the internal review URL may be preserved by the Glean launch login flow. */
export function gleanReviewIdFromReturnTo(value: string | null): string | null {
  return value?.match(/^\/workspace\/glean\/review\/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})$/i)?.[1] ?? null;
}
